// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Grid, Divider, Button, Image, Segment, Placeholder, Container } from 'semantic-ui-react'
import putyou from '../assets/putyou.png'
import PricingTable from '../components/PricingTable'
import main from '../assets/pricing.png'
import Img from 'react-image'

const ImgLoader = (
  <Placeholder fluid style={{ height: 300 }}>
    <Placeholder.Image />
  </Placeholder>
)

export default class Pricing extends Component {
  render () {
    return (
      <div className='overview' style={{ backgroundColor: 'transparent' }}>
        <div className='center mtb'>
          <h2>Pricing</h2>
        </div>

        <div className='mtb center'>
          <Button
            size='large'
            style={{
              backgroundColor: '#f7d170',
              borderColor: '#000',
              color: '#000',
              borderStyle: 'solid',
              borderWidth: '2px'
            }}
            href='/signup'>
            Start your free trial
          </Button>
          <br />
          <h4>No coding skills required.</h4>
        </div>

        <div className='mtb'>
          <div className='mt'>
            <Grid verticalAlign='middle' stackable>
              <Grid.Column width='5'>
                <Segment padded basic>
                  <h4>
                    <b>How many apps are included?</b>
                  </h4>
                  <h5>Only one app is included in the subscription.</h5>
                  <Divider />
                  <h4>
                    <b>Are there any other costs involved?</b>
                  </h4>
                  <h5>
                    You must purchase your own Apple and Android developer accounts, for $99/year
                    and $25 respectively.
                  </h5>
                  <Divider />
                  <h4>
                    <b>Can I cancel my plan at any time?</b>
                  </h4>
                  <h5>
                    Yes! You can. The Cancellation becomes effective at
                    the end of the current billing period. You have access to your mobile app until
                    then. Please visit <a href='/settings'>account settings</a> if you wish to
                    cancel.
                  </h5>
                </Segment>
              </Grid.Column>
              <Grid.Column width='6'>
                <PricingTable />
              </Grid.Column>
              <Grid.Column width='5'>
                <div className='center'>
                  <p>Didn't find what you were looking for?</p>
                  <h4>No problem!</h4>
                  <Image centered src={putyou} size='small' />
                  <Button
                    basic
                    color='black'
                    href='https://murkstom.joliefaq.io/'
                    target='_blank'
                    rel='noopener noreferrer'>
                    Visit Help Center
                  </Button>
                  <Button basic color='black' href='/contact'>
                    Get in touch
                  </Button>
                </div>
              </Grid.Column>
            </Grid>
          </div>
        </div>

        <Grid verticalAlign='middle' stackable className='mt' centered celled>
          <Grid.Column width='16'>
            <div className='mtb'>
              <Grid verticalAlign='middle' stackable className='mt' centered>
                <Grid.Column width='4' />
                <Grid.Column width='8'>
                  <Container padded>
                    <h3>$25</h3>
                    <h3>MurkstomDeploy</h3>
                    <div className='mb'>
                      <h4>
                        We can help you deploy the app to both Apple Store and Google Play, this
                        service also includes generating icons and screenshots.
                      </h4>
                    </div>
                    <Button
                      href='https://buy.paddle.com/product/588435'
                      target='_blank'
                      rel='noopener noreferrer'
                      size='large'
                      color='black'>
                      Checkout
                    </Button>
                  </Container>
                </Grid.Column>
                <Grid.Column width='4' />
              </Grid>
            </div>
          </Grid.Column>
        </Grid>

        <Grid verticalAlign='middle' stackable className='mt' centered celled>
          <Grid.Column width='16'>
            <div className='mtb'>
              <Grid verticalAlign='middle' stackable className='mt' centered>
                <Grid.Column width='4' />
                <Grid.Column width='8'>
                  <Container padded>
                    <h3>$290</h3>
                    <h3>MurkstomSource</h3>
                    <div className='mb'>
                      <h4>
                        Buy the source code of our mobile app template for a one time fee. Reduce
                        time-to-market by starting with a solid base and main functionalities
                        already implemented. License is for personal and commercial use. Code is
                        well documented and written in React Native (JavaScript).
                      </h4>
                    </div>
                    <Button
                      href='https://buy.paddle.com/product/579576'
                      target='_blank'
                      rel='noopener noreferrer'
                      size='large'
                      color='black'>
                      Checkout
                    </Button>
                  </Container>
                </Grid.Column>
                <Grid.Column width='4' />
              </Grid>
            </div>
          </Grid.Column>
        </Grid>

        <h5 className='center mt'>All prices in USD</h5>
        <br />
      </div>
    )
  }
}
